/* BASIC APP CONSTANTS */
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const APP_COOKIE_NAME = "APP_COOKIE_NAME";
export const USER_COOKIE_NAME = "USER_COOKIE_NAME";
export const PASS_COOKIE_NAME = "PASS_COOKIE_NAME";
export const USER_ID_COOKIE_NAME = "USER_ID_COOKIE_NAME";
export const SET_CURRENT_ROUTE = "SET_CURRENT_ROUTE";
export const SET_SIDE_MENU_STATE = "SET_SIDE_MENU_STATE";
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const CLOSE_NOTIFICATION = "CLOSE_NOTIFICATION";
export const SHOW_ACTION_MENU = "SHOW_ACTION_MENU";
export const HIDE_ACTION_MENU = "HIDE_ACTION_MENU";
export const SHOW_BOTTOM_TOOLBAR = "SHOW_BOTTOM_TOOLBAR";
export const HIDE_BOTTOM_TOOLBAR = "HIDE_BOTTOM_TOOLBAR";
export const SET_USER_LIST = "SET_USER_LIST";
export const EDIT_DISABLED_BUTTONS = "EDIT_DISABLED_BUTTONS";
export const SET_LOGS_LIST = "SET_LOGS_LIST";
export const THEME = "THEME";

/* <---- BASIC APP CONSTANTS ----> */

/* SOCKET CONSTANTS */
export const CONNECTED = "connected";
export const DISCONNECTED = "disconnected";
/* <---- SOCKET CONSTANTS ----> */

/* CONFIGURATION */
export const CONFIGURATION_FORM_TOOGLE_LOADING =
  "CONFIGURATION_FORM_TOOGLE_LOADING";
export const SET_CONFIGURATION = "SET_CONFIGURATION";
/* <---- CONFIGURATION ----> */

/* USER */
export const SET_PROFILE = "SET_PROFILE";
/* <---- USER ----> */

/* USERS */
export const ADD_NEW_USER = "ADD_NEW_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const OPEN_USER_FORM = "OPEN_USER_FORM";
export const CLOSE_USER_FORM = "CLOSE_USER_FORM";
export const EDIT_SELECTED_USER = "EDIT_SELECTED_USER";
export const USERS_FORM_TOOGLE_LOADING = "USERS_FORM_TOOGLE_LOADING";
/* <---- USERS ----> */

/* MACHINE */
export const SET_MACHINE_LIST = "SET_MACHINE_LIST";
export const ADD_NEW_MACHINE = "ADD_NEW_MACHINE";
export const UPDATE_MACHINE = "UPDATE_MACHINE";
export const DELETE_MACHINE = "DELETE_MACHINE";
export const OPEN_MACHINE_FORM = "OPEN_MACHINE_FORM";
export const CLOSE_MACHINE_FORM = "CLOSE_MACHINE_FORM";
export const EDIT_SELECTED_MACHINE = "EDIT_SELECTED_MACHINE";
export const MACHINE_FORM_TOOGLE_LOADING = "MACHINE_FORM_TOOGLE_LOADING";
export const UPDATE_MACHINE_FORM_DATA = "UPDATE_MACHINE_FORM_DATA";
export const OPEN_CALIBRATION_FORM = "OPEN_CALIBRATION_FORM";
export const CLOSE_CALIBRATION_FORM = "CLOSE_CALIBRATION_FORM";
export const CALIBRATION_FORM_TOGGLE_LOADING =
  "CALIBRATION_FORM_TOGGLE_LOADING";
export const ADD_CALIBRATION_TO_MACHINE = "ADD_CALIBRATION_TO_MACHINE";
export const UPDATE_MACHINE_CALIBRATIONS = "UPDATE_MACHINE_CALIBRATIONS";
export const OPEN_PROGRAMS_FORM = "OPEN_PROGRAMS_FORM";
export const CLOSE_PROGRAMS_FORM = "CLOSE_PROGRAMS_FORM";
export const PROGRAMS_FORM_TOGGLE_LOADING = "PROGRAMS_FORM_TOGGLE_LOADING";
export const UPDATE_MACHINE_PROGRAMS = "UPDATE_MACHINE_PROGRAMS";
export const OPEN_DOSIFICATIONS_FORM = "OPEN_DOSIFICATIONS_FORM";
export const CLOSE_DOSIFICATIONS_FORM = "CLOSE_DOSIFICATIONS_FORM";
export const DOSIFICATIONS_FORM_TOGGLE_LOADING =
  "DOSIFICATIONS_FORM_TOGGLE_LOADING";
export const UPDATE_MACHINE_DOSIFICATIONS = "UPDATE_MACHINE_DOSIFICATIONS";
export const SELECT_PROGRAM_FOR_DOSIFICATION =
  "SELECT_PROGRAM_FOR_DOSIFICATION";
export const SELECT_WASHER_FOR_DOSIFICATION =
  "SELECT_WASHER_FOR_DOSIFICATION";
/* <---- MACHINE ----> */

/* LAUNDRY */
export const SET_LAUNDRY_LIST = "SET_LAUNDRY_LIST";
export const ADD_NEW_LAUNDRY = "ADD_NEW_LAUNDRY";
export const UPDATE_LAUNDRY = "UPDATE_LAUNDRY";
export const DELETE_LAUNDRY = "DELETE_LAUNDRY";
export const OPEN_LAUNDRY_FORM = "OPEN_LAUNDRY_FORM";
export const CLOSE_LAUNDRY_FORM = "CLOSE_LAUNDRY_FORM";
export const EDIT_SELECTED_LAUNDRY = "EDIT_SELECTED_LAUNDRY";
export const LAUNDRY_FORM_TOOGLE_LOADING = "LAUNDRY_FORM_TOOGLE_LOADING";
/* <---- LAUNDRY ----> */

/* CUSTOMER */
export const SET_CUSTOMER_LIST = "SET_CUSTOMER_LIST";
export const ADD_NEW_CUSTOMER = "ADD_NEW_CUSTOMER";
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const DELETE_CUSTOMER = "DELETE_CUSTOMER";
export const OPEN_CUSTOMER_FORM = "OPEN_CUSTOMER_FORM";
export const CLOSE_CUSTOMER_FORM = "CLOSE_CUSTOMER_FORM";
export const EDIT_SELECTED_CUSTOMER = "EDIT_SELECTED_CUSTOMER";
export const CUSTOMER_FORM_TOOGLE_LOADING = "CUSTOMER_FORM_TOOGLE_LOADING";
/* <---- CUSTOMER ----> */

/* ROUTES */
export const SET_ALL_ROUTES = "SET_ALL_ROUTES";
export const UPDATE_ROUTE = "UPDATE_ROUTE";
/* <---- ROUTES ----> */

/* ALERT */
export const SET_ALERT_LIST = "SET_ALERT_LIST";
export const ADD_NEW_ALERT = "ADD_NEW_ALERT";
export const UPDATE_ALERT = "UPDATE_ALERT";
export const DELETE_ALERT = "DELETE_ALERT";
export const OPEN_ALERT_FORM = "OPEN_ALERT_FORM";
export const CLOSE_ALERT_FORM = "CLOSE_ALERT_FORM";
export const EDIT_SELECTED_ALERT = "EDIT_SELECTED_ALERT";
export const ALERT_FORM_TOOGLE_LOADING = "ALERT_FORM_TOOGLE_LOADING";
/* <---- ALERT ----> */
